import ScreenInfo from "./ScreenInfo";

export default ScreenInfo;